<template>
  <div>
    <description :event="event" v-if="event.Description" />
    <teams :event="event" v-else />
    
    <win-probability :event="event" v-if="event.StatusComplete != 1 && event.WinProbAway > 0 && event.WinProbHome > 0"/>
    
    
  </div>
</template>

<script>
import Description from "./Description";
import Teams from "./Teams";
import WinProbability from "./Teams/WinProbability"

export default {
  name: "EventDetails",
  components: {
      Teams,
      Description,
      WinProbability
  },
  props: {
    event: Object
  },
};
</script>